import { BUSINESS_SECTOR_ENUM } from '../interfaces';

// i18n keys under businessAccountRequest:sector.*
export const BUSINESS_SECTOR_OPTIONS = Object.values(BUSINESS_SECTOR_ENUM).map((value) => ({
  value,
  label: `businessAccountRequest:sector.${value}`,
  translate: true,
}));
